import Api from ".";
import { downloadFile } from "../Utils/FileUploadService";
import { sanitizeFileName } from "../utils";
import { AZUREURL } from "./envUrl";

export const downloadAzureContainer = async (
  fileName,
  folderStructure,
  headers = {}
) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  apiURL = `${AZUREURL}/downloadFileFromContainerPath?path=/${sanitizeFileName(folderStructure)}&file=${sanitizeFileName(fileName)}`;
  try {
    // Make a GET request to download the file
    const response = await axiosInstance({
      url: apiURL,
      method: 'GET',
      responseType: 'blob',
      // Specify the response type as blob for file downloads
    });

    // Create a temporary anchor element to trigger the download
    downloadFile(response.data, fileName)

    return true; // Successful download
  } catch (error) {
    console.error('Error downloading file:', error);
    return false; // Failed download
  }
};

export const bulkDownload = async (payload, fileName = "files") => {
  const api = new Api();
  const axiosInstance = await api.init({
    "Content-Type": "application/json",
  });
  const apiURL = `${AZUREURL}/bulkDownloadTDFiles`;

  const response = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: payload,
    responseType: "blob",
  });

  // Create ZIP blob
  const blob = new Blob([response.data], {
    type: "application/zip",
  });

  // Create download link
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `${fileName}.zip`;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};